export const UPDATES_FREQUENCY_EVERY_PERIOD = "UPDATES_FREQUENCY_EVERY_PERIOD";
export const UPDATES_FREQUENCY_EVERY_SCHEDULED = "UPDATES_FREQUENCY_EVERY_SCHEDULED";
export const UPDATES_FREQUENCY_EVERY_MANUAL = "UPDATES_FREQUENCY_EVERY_MANUAL";